import { useState, useEffect, useRef } from 'react';
import { authService } from '../services/authService';

export const useAuth = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const initializeRef = useRef(false); // Prevent multiple initializations

  useEffect(() => {
    // Only initialize once
    if (!initializeRef.current) {
      initializeRef.current = true;
      initializeAuth();
    }
  }, []);

  const initializeAuth = async () => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      const error = urlParams.get('error');

      if (error || code) {
        await handleAuthCallback();
      } else {
        await checkAuth();
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleAuthCallback = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const error = urlParams.get('error');

    if (error) {
      throw new Error(`Authentication failed: ${error}`);
    }

    if (code) {
      const userData = await authService.handleCallback(code);
      setUser(userData);
    }

    // Clean up URL
    window.history.replaceState({}, document.title, window.location.pathname);
  };

  const checkAuth = async () => {
    try {
      const userData = await authService.getCurrentUser();
      setUser(userData);
    } catch (err) {
      // User not authenticated
      setUser(null);
    }
  };

  const login = async () => {
    try {
      setError(null);
      await authService.login();
    } catch (err) {
      setError(err.message);
    }
  };

  const logout = async () => {
    try {
      await authService.logout();
      setUser(null);
    } catch (err) {
      setError(err.message);
    }
  };

  return {
    user,
    loading,
    error,
    login,
    logout,
    checkAuth, // Exposer checkAuth pour permettre le rafraîchissement
    isAuthenticated: !!user
  };
};